import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-payment-gateway',
  templateUrl: './dialog-payment-gateway.component.html',
  styleUrls: ['./dialog-payment-gateway.component.css']
})
export class DialogPaymentGatewayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
